import * as React from "react";
import Translate from '../../../common/functions/translate';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import { UserDiseaseHistoryModel } from "../../../models/user/userDiseaseHistoryModel";
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Growl from "../../../common/components/alertMessage/growl";
import { UserDiseaseModel } from "../../../models/user/userDiseaseModel";
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { faCheck, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import DiseaseListDialog from "./diseaseListDialog";
import { DiseaseForGridModel } from "../../../models";

interface IProps {
  //history: any,
  addClick: any,
  updateClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentUserDiseaseHistory: UserDiseaseHistoryModel,
  userId: number,
  lang: string
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  currentUserDiseaseHistory: UserDiseaseHistoryModel,
  userDisease: UserDiseaseModel,
  isVisibleSearchDiseaseDialog: boolean
}

class UserDiseaseHistoryAddEditDialog extends React.Component<IProps, IState> {
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      isLoading: false,
      currentUserDiseaseHistory: props.currentUserDiseaseHistory,
      userDisease: new UserDiseaseModel(),
      isVisibleSearchDiseaseDialog: false
    };
  }

  componentDidMount() {
  }

  handleAddButton = (event) => {
    event.preventDefault();

    const currentUserDiseaseHistory = this.state.currentUserDiseaseHistory;

    if (currentUserDiseaseHistory.startDate) {
      currentUserDiseaseHistory.startDate = HelperFunctions.fomatDateAsString(new Date(currentUserDiseaseHistory.startDate))
    } else {
      currentUserDiseaseHistory.startDate = HelperFunctions.fomatDateAsString(new Date())
    }

    if (currentUserDiseaseHistory.endDate) {
      currentUserDiseaseHistory.endDate = HelperFunctions.fomatDateAsString(new Date(currentUserDiseaseHistory.endDate))
    } else {
      currentUserDiseaseHistory.endDate = HelperFunctions.fomatDateAsString(HelperFunctions.getDayslater(new Date().toString(), 7))
    }

    if (currentUserDiseaseHistory && currentUserDiseaseHistory.userDiseaseHistoryId && currentUserDiseaseHistory.userDiseaseHistoryId > 0) {
      this.props.updateClick(currentUserDiseaseHistory, close);
    }
    else {
      this.props.addClick(currentUserDiseaseHistory, this.state.userDisease, close);
    }
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleChange = (key, value) => {
    const currentUserDiseaseHistory: UserDiseaseHistoryModel = { ...this.state.currentUserDiseaseHistory };
    currentUserDiseaseHistory[key] = value;
    this.setState({ currentUserDiseaseHistory: { ...currentUserDiseaseHistory } });
  };

  handleDiseaseRemoveClick(event) {
    event.preventDefault();
    this.setState({
      userDisease: new UserDiseaseModel()
    });
  }

  handleDiseaseAddEditClick() {
    this.setState({
      isVisibleSearchDiseaseDialog: true,
      validationMessage: ''
    });
  }

  handleAddSaveButton = (currentUserDisease: UserDiseaseModel, close: boolean) => {
    this.setState({
      isVisibleSearchDiseaseDialog: false,
      userDisease: currentUserDisease
    });
  }

  handleDiseaseListDialogCancelButton = () => {
    this.setState({
      isVisibleSearchDiseaseDialog: false,
    });
  }

  public render() {
    const { isLoading, currentUserDiseaseHistory, userDisease } = this.state;

    let diseaseInputButton =
      <div style={{ paddingLeft: '7px' }}>
        <label>{Translate('Disease')}:</label>
        <div>
          {currentUserDiseaseHistory.diseaseCode + currentUserDiseaseHistory.diseaseName ? currentUserDiseaseHistory.diseaseName : null}
        </div>
      </div>;
    if (!currentUserDiseaseHistory || !currentUserDiseaseHistory.userDiseaseHistoryId || currentUserDiseaseHistory.userDiseaseHistoryId == 0) {
      let classInput = 'float-left-full-width';
      if (!userDisease || !userDisease.disease || !userDisease.disease.diseaseId) {
        classInput = 'float-left-calculated-width';
      }
      diseaseInputButton =
        <div style={{ width: '100%', paddingLeft: '7px' }}>
          <div className="clearfix">
            <div className={classInput}>
              <label>{Translate('Disease')}:</label>
              {userDisease && userDisease.disease && userDisease.disease.diseaseId ?
                <>
                  <ul className="list-items">
                    <li style={{ border: 'none' }}>
                      <div className="item-info">
                        <div className="item-name" style={{ fontSize: '0.9em' }}>
                          {userDisease.disease.diseaseCode + userDisease.disease.diseaseName ? userDisease.disease.diseaseName : ''}
                        </div>
                      </div>
                      <div className="item-actions">
                        <span>
                          <a href='' onClick={(e) => this.handleDiseaseRemoveClick(e)} title={Translate('Remove')} >
                            <FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
                          </a>
                        </span>
                      </div>
                    </li>
                  </ul>
                </>
                : <div style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate('No disease selected')}</i></div>}
            </div>
            {!userDisease || !userDisease.disease || !userDisease.disease.diseaseId ?
              <div style={{ width: "41px", float: "right" }} className="mb-10">
                <Fab color="primary" size="small" aria-label="Add" onClick={() => this.handleDiseaseAddEditClick()}>
                  <AddIcon />
                </Fab>
              </div> : null}
          </div>
        </div>;
    }


    return (
      <>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Disease History')}</Modal.DialogTitle>
          <Modal.DialogContent>
            <div>
              <Growl ref={(el) => this.growl = el} />
              {diseaseInputButton}
              <div className="p-grid p-fluid p-md-12">
                <div className="p-col-12 p-md-6">
                  <DatePicker
                    format={Translate('DateFormat')}
                    margin="normal"
                    label={Translate('Start Date')}
                    value={currentUserDiseaseHistory.startDate ? new Date(currentUserDiseaseHistory.startDate) : new Date()}
                    onChange={(e) => this.handleChange('startDate', e)}
                  />
                </div>
                <div className="p-col-12 p-md-6">
                  <DatePicker
                    format={Translate('DateFormat')}
                    margin="normal"
                    label={Translate('End Date')}
                    value={currentUserDiseaseHistory.endDate ? new Date(currentUserDiseaseHistory.endDate) : HelperFunctions.getDayslater(new Date().toString(), 7)}
                    onChange={(e) => this.handleChange('endDate', e)}
                  />
                </div>
                <div className="p-col-12 p-md-12" >
                  <div>
                    <TextField
                      autoComplete="off"
                      id="standard-name"
                      label={Translate('Comments')}
                      value={currentUserDiseaseHistory && currentUserDiseaseHistory.comments ? currentUserDiseaseHistory.comments : ""}
                      onChange={(e) => this.handleChange('comments', e.target['value'])}
                      margin="none"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                {Translate('Cancel')}
              </Button>
              <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleAddButton(e)}
                disabled={(!currentUserDiseaseHistory || !currentUserDiseaseHistory.userDiseaseHistoryId || currentUserDiseaseHistory.userDiseaseHistoryId == 0) &&
                  (!userDisease || !userDisease.disease || !userDisease.disease.diseaseId)}>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                {Translate('Save')}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog>
        {this.state.isVisibleSearchDiseaseDialog ? (
          <DiseaseListDialog
            userId={this.props.userId}
            selectedDisease={new DiseaseForGridModel()}
            addClick={this.handleAddSaveButton}
            cancelClick={this.handleDiseaseListDialogCancelButton}
            isVisible={this.state.isVisibleSearchDiseaseDialog}
            lang={this.props.lang}
          />
        ) : null}
      </>
    )
  }
}

export default UserDiseaseHistoryAddEditDialog;